<p>agent works!</p>
<button (click)="login()">Login</button>
<div>{{ loginDisplay }}</div>